<!-- 软件应用 -->
<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <!-- 头部 -->
        <div class="header_container">
          <span class="header_title">软件应用</span>
          <span class="header_dec">各种实用工具</span>
        </div>
        <!-- 内容 -->
        <div class="content_container">
          <div class="content_container1">
            <div class="item_contain" v-for="item in items">
              <span class="item_tittle">{{item.title}}</span>
              <span class="item_dec">{{item.dec}}</span>
              <span class="item_hint">扫码体验</span>
              <img class="item_img" :src="item.img" />
            </div>
          </div>
          <!-- 分割线 -->
          <div class="line"></div>
        </div>
      </div>
    </div>

    <div class="phone_container">
      <div class="phone_body_container">
        <!-- 头部 -->
        <div class="phone_header_container">
          <span class="phone_header_title">软件应用</span>
          <span class="phone_header_dec">各种实用工具</span>
        </div>
        <!-- 内容 -->
        <div class="phone_content_container">
            <div class="phone_item_contain" v-for="item in items">
              <div class="phone_title_bg">
                <span class="phone_item_tittle">{{item.title}}</span>
              </div>
              <span class="phone_item_dec">{{item.dec}}</span>
              <span class="phone_item_hint">扫码体验</span>
              <img class="phone_item_img" :src="item.img" />
            </div>
          <!-- 分割线 -->
          <div class="phone_line"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'application',
    data() {
      return {
        items: [{
            title: '小慧计数小程序',
            dec: '方便团队记录、管理数据',
            img: require('../assets/application/ico_little_code.png'),
            index: 0
          },
          {
            title: '清兮',
            dec: '清者静兮，静者乐兮',
            img: require('../assets/application/ico_app_qx_code.png'),
            index: 1
          },
        ],
      };
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: ht;
    src: url("../assets/font/HT.otf");
  }

  .web_container {
    width: 100%;
  }

  .body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_container {
    background-size: 100%;
    width: 100%;
    height: 25vw;
    background-image: url('../assets/home/bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_title {
    font-family: ht;
    font-size: 2.5vw;
    color: #000000;
    margin-top: 15.989583vw;
  }

  .header_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 1.25vw;
  }

  .content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content_container1 {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .item_contain {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 8.333333vw;
  }

  .item_contain:nth-of-type(1) {
    margin-left: 1.041666vw;
  }

  .item_tittle {
    font-family: ht;
    font-size: 1.666666vw;
    color: #000000;
  }

  .item_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 0.416666vw;
  }

  .item_hint {
    font-family: ht;
    font-size: 0.833333vw;
    color: rgba(78, 77, 77, 0.6);
    margin-top: 2.083333vw;
  }

  .item_img {
    height: 10vw;
    width: 10vw;
    margin-top: 0.833333vw;
  }

  .line {
    height: 0.052083vw;
    width: 52.083333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 4.166666vw;
    margin-bottom: 4.166666vw;
  }

  .phone_container {
    width: 100%;
  }

  .phone_body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_container {
    background-size: 100%;
    width: 100%;
    height: 78.933333vw;
    background-image: url('../assets/home/phone_bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .phone_header_title {
    font-family: ht;
    font-size: 6.4vw;
    color: #000000;
    margin-top: 38.933333vw;
  }

  .phone_header_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 2.133333vw;
  }

  .phone_content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_item_contain {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom:21.333333vw;
  }

  .phone_title_bg{
    background-size: 100%;
    width: 53.066666vw;
    height:12vw;
    background-image: url('../assets/application/phone_bg_title.png');
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .phone_item_tittle {
    font-family: ht;
    font-size: 5.333333vw;
    color: #000000;
  }

  .phone_item_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
  }

  .phone_item_hint {
    font-family: ht;
    font-size: 3.733333vw;
    color: rgba(78, 77, 77, 0.6);
    margin-top: 8.533333vw;
  }

  .phone_item_img {
    height: 32vw;
    width: 32vw;
    margin-top:4.266666vw;
  }
  .phone_line {
    height: 0.266666vw;
    width: 89.333333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 17.066666vw;
    margin-bottom: 8.266666vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/Application.vue